import React from 'react';
import { Button, Typography } from '@guildeducationinc/recess';
import './ErrorMessage.scss';

const ErrorMessage: React.FC = () => {
  return (
    <div className='error-message'>
      <Typography variant='title2'>Something didn&apos;t work quite right.</Typography>
      <Typography variant='body1'>Try refreshing the page to continue.</Typography>
      <Button className='error-message__action' onClick={() => window.location.reload()}>
        Refresh Page
      </Button>
    </div>
  );
};

export default ErrorMessage;
